export default __webpack_public_path__ + "static/media/screen4.6640ae96.png";